import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SignupComponent} from './signup/signup.component';
import {SigninComponent} from './signin/signin.component';
import {UserComponent} from './user/user.component';
import {BillsComponent} from './bills/bills.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {SummaryComponent} from './summary/summary.component';
import {CheckoutComponent} from './checkout/checkout.component';
import {CguComponent} from './cgu/cgu.component';
import {SwitchCompanyComponent} from './switch-company/switch-company.component';
import {DownloadBillComponent} from './download-bill/download-bill.component';
import {MandatRedirectComponent} from './mandat-redirect/mandat-redirect.component';
import {MandatSignComponent} from './mandat-sign/mandat-sign.component';
import {canAccess} from './core/auth/user-route-access-service';
import {SsoInexwebLoggedComponent} from "./sso-inexweb-logged/sso-inexweb-logged.component";
import {MandatRegisterComponent} from "./mandat-register/mandat-register.component";
import {CheckoutRedirectComponent} from "./checkout-redirect/checkout-redirect.component";

const routes: Routes = [
  {path: 'register', component: SignupComponent},
  {path: 'login', component: SigninComponent},
  {path: 'informations', component: UserComponent, canActivate: [canAccess]},
  {path: 'bills', component: BillsComponent, canActivate: [canAccess]},
  {path: 'reset-password', component: ResetPasswordComponent},
  {path: 'summary', component: SummaryComponent, canActivate: [canAccess]},
  {path: 'paiement/checkout/:id', component: CheckoutComponent},
  {path: 'paiement/notify/:typeRetour/:ref', component: CheckoutRedirectComponent},
  {path: 'mandat', redirectTo: 'mandat/sign', pathMatch: 'full'},
  {path: 'mandat/sign', component: MandatSignComponent, canActivate: [canAccess]},
  {path: 'mandat/create', component: MandatRegisterComponent},
  {path: 'mandat/:type', component: MandatRedirectComponent},
  {path: 'cgu', component: CguComponent},
  {path: 'switch-company', component: SwitchCompanyComponent, canActivate: [canAccess]},
  {path: 'download-bill/:id', component: DownloadBillComponent},
  {path: 'inexweb/logged', component: SsoInexwebLoggedComponent},
  {path: '', component: SummaryComponent, canActivate: [canAccess]},
  {path: '**', component: SummaryComponent, canActivate: [canAccess]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
